module.exports = __webpack_public_path__ + "img/gold-ingots.85fe93f3.svg";